import styles from "./index.module.less";
import { useCallback, useEffect, useState } from "react";
import HBIcon from "@/components/HBIcon";
import { If, Then, Else } from "react-if";
import classNames from "classnames";
import useAppStore from "@/context/store";

export default function LetterNav({
  list = [],
  container = null,
  offset = 0,
  visible: _visible = false,
}) {
  const [visible, setVisible] = useState(_visible);
  const [activeIndex, setActiveIndex] = useState(null);
  const height = useAppStore((store) => store.headerHeight);
  const headerHeight = height + offset;
  useEffect(() => {
    const onScroll = () => {
      if (container) {
        if (!_visible) {
          const rect = container.getBoundingClientRect();
          setVisible(rect.top - headerHeight <= 0);
        }

        const activeIndex = list.findIndex((_, index) => {
          const el = container.querySelector(`.letter-${index}`);
          const position = el?.getBoundingClientRect();
          return position?.bottom >= headerHeight;
        });
        setActiveIndex(activeIndex);
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [container, list, headerHeight, _visible]);

  const onSelect = useCallback(
    (index) => {
      if (container) {
        const el = container.querySelector(`.letter-${index}`);
        const position = el?.getBoundingClientRect();
        window.scrollTo({
          top: position.top + window.scrollY - headerHeight,
          behavior: "smooth",
        });
      }
    },
    [container, headerHeight]
  );

  return (
    <div
      className={classNames([styles.letterNav, visible ? styles.show : null])}
    >
      <ul className={styles.list}>
        {list.map((item, index) => (
          <If condition={item.icon} key={item.title}>
            <Then>
              <li
                className={classNames([
                  styles.item,
                  activeIndex === index ? styles.active : null,
                ])}
                onClick={() => onSelect(index)}
              >
                <HBIcon type={item.icon} />
              </li>
            </Then>
            <Else>
              <li
                className={classNames([
                  styles.item,
                  activeIndex === index ? styles.active : null,
                ])}
                onClick={() => onSelect(index)}
              >
                {item.title.toUpperCase()}
              </li>
            </Else>
          </If>
        ))}
      </ul>
    </div>
  );
}
